import { createSlice } from "@reduxjs/toolkit";
import { English, Spanish } from '../../localization/Languages'

const initialState = {
    language: English,
    checkedStatus: false
}

const languageSlice = createSlice({
    name: 'languages',
    initialState,
    reducers: {
        languages: (state, action) => {
            state.language = action.payload ? Spanish : English
            state.checkedStatus = action.payload
        },
        resetLanguages: (state, action) => {
            state.language = English
            state.checkedStatus = false
        }
    }
}
)

export const { languages, resetLanguages } = languageSlice.actions
export const language = state => state.languages.language

export default languageSlice.reducer